import { useState } from 'react';
import { MdOutlineStar } from 'react-icons/md';
import cn from 'classnames';

export interface StarRatingProps {
  value: number;
  total?: number;
  showValue?: boolean;
  size?: number;
  className?: string;
  readOnly?: boolean;
  onChange?: (value: number) => void;
}

const StarRating = ({
  value,
  total = 5,
  showValue = false,
  size = 20,
  className,
  readOnly = false,
  onChange,
}: StarRatingProps) => {
  const [hoverValue, setHoverValue] = useState<number | null>(null);

  const displayValue = hoverValue ?? value;

  const handleClick = (starIndex: number) => {
    if (!readOnly && onChange) {
      onChange(starIndex);
    }
  };

  const handleMouseEnter = (starIndex: number) => {
    if (!readOnly) {
      setHoverValue(starIndex);
    }
  };

  const handleMouseLeave = () => {
    if (!readOnly) {
      setHoverValue(null);
    }
  };

  return (
    <div className={cn('flex items-center gap-0', className ?? '')}>
      <div className="flex items-center">
        {Array.from({ length: total }, (_, i) => {
          const starNumber = i + 1;
          const isActive = starNumber <= displayValue;

          return (
            <div
              key={starNumber}
              className={cn(isActive ? 'text-base-5' : 'text-base-50', {
                'hover:text-base-5': !readOnly,
              })}
            >
              <MdOutlineStar
                size={size}
                onClick={() => handleClick(starNumber)}
                onMouseEnter={() => handleMouseEnter(starNumber)}
                onMouseLeave={handleMouseLeave}
              />
            </div>
          );
        })}
      </div>
      {showValue && <span className="text-m-r text-base-5 tabular-nums ml-2">{value}</span>}
    </div>
  );
};

export default StarRating;
